import React, { useCallback, useState } from 'react';
import { usePlacesWidget } from 'react-google-autocomplete';

import Input from 'components/shared/input';
import SearchIcon from 'icons/search.svg';

import PropTypes from 'prop-types';
import { api, GOOGLE_MAPS_API_KEY } from '../utils';
import styles from './styles.module.scss';
import Button from '../../../shared/button';

import { BUTTON_SIZES } from '../../../../constants/button';

const SearchProperty = ({ boxId = undefined, formId = undefined }) => {
  const [property, setProperty] = useState();
  const [showRegisterProperty, setShowRegisterProperty] = useState(false);

  const gedPropertyByAddress = useCallback(async (address) => {
    const { data } = await api.get('/property-by-address', { params: { addressSearch: address } });

    setProperty(data.name ? data : undefined);
    setShowRegisterProperty(!data?.name);
  }, []);

  const { ref } = usePlacesWidget({
    apiKey: GOOGLE_MAPS_API_KEY,
    libraries: ['places'],
    componentRestrictions: { country: 'us' },
    options: {
      types: ['geocode', 'establishment'],
    },
    onPlaceSelected: (place) => {
      gedPropertyByAddress(place.formatted_address?.replace(', USA', ''));
    },
  });

  const onTryNowPress = useCallback(() => {
    if (window?.RGWidgetOpts?.openWidget && property?.buildingID) {
      window?.RGWidgetOpts?.openWidget(property.buildingID, property.name);
    } else {
      window?.console.error('RGWidgetOpts is not defined');
    }
  }, [property]);

  return (
    <div id={boxId} className={styles.search}>
      <h3 className={styles.title}>Try the bot for your property</h3>
      <div className={styles.searchBox}>
        <div className={styles.field}>
          <Input
            ref={ref}
            name="appartment"
            placeholder="Enter Your Apartment Community Address"
            withBorder
          />
          <img className={styles.searchIcon} src={SearchIcon} alt="search" />
        </div>
      </div>
      {property && (
        <div className={styles.property}>
          <div>
            <h4 className={styles.subTitle}>{property.name}</h4>
            <p>{property.address}</p>
          </div>
          <div>
            <Button
              type="button"
              theme="accent-primary"
              size={BUTTON_SIZES.SM}
              onClick={onTryNowPress}
            >
              Try Now
            </Button>
          </div>
        </div>
      )}
      {showRegisterProperty && (
        <div className={styles.propNotFound}>
          <h4 className={styles.subTitle}>Your Property is not registered with Swiftlane</h4>
          <a href={`#${formId}`}>
            <Button type="button" theme="accent-primary" size={BUTTON_SIZES.SM}>
              Register Property
            </Button>
          </a>
        </div>
      )}
    </div>
  );
};


SearchProperty.propTypes = {
  boxId: PropTypes.string,
  formId: PropTypes.string,
};

export default SearchProperty;
